import httpService from "../httpService";
const orderCount = {
    namespaced: true,
    state: {
        totalOrderCount: '',
        userOrderCount: '',
        loader: false
    },
    mutations: {
        setTotalOrderCount(state,payload) {
            state.totalOrderCount  = payload
        },
        setUserOrderCount(state,payload) {
            state.userOrderCount= payload
        },
       
    },
    actions: {
        getUserOrderCount({commit}, payload){
            commit('SET_LOADER', true, {root: true})
            httpService.getUserOrderCount(payload).then((res)=> {
                if(res.status == 200 && res.data.stat == 'Ok' && res.data.message == 'SUCCESS' && res.data.result && res.data.result.length > 0){
                    commit('setUserOrderCount', res.data.result) 
                } else if (res.data.stat == 'Not_Ok' && res.data.message == 'No DataS') {
                    commit('setUserOrderCount', [])
                }
            }, (err)=> {
                console.error(err);
            }).finally(()=> {
                commit('SET_LOADER', false, {root: true})
            })
        },
        getTotalOrderCount({commit}, payload) {
                         httpService.getTotalOrderCount(payload).then((res)=> {
                if(res.status == 200 && res.data.stat == 'Ok' && res.data.message == 'SUCCESS' && res.data.result){
                    commit('setTotalOrderCount', res.data.result)
                }
            }, (err)=> {
                console.error(err)}).finally(()=> {
    
            })
        }
    }
}

export default orderCount;